import { AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"

export type EventLogSummary = {
	userName: string
	timestamp: string
	fixKey: string
	patientConditionId: number
	patientName: string
	assessmentId: number
}

type EventLogsResponse = {
	count: number
	logs: EventLogSummary[]
}

export class EventLogClient {
	constructor(private axiosClient: AxiosInstance) {}

	public getEventLog = ({
		pageIndex,
		pageSize
	}: {
		pageIndex: number
		pageSize: number
	}) => {
		const query = new URLSearchParams()
		query.append("page", pageIndex.toString())
		query.append("pageSize", pageSize.toString())

		return handleQueryResult(
			this.axiosClient.get<EventLogsResponse>(
				`/api/admin/investigations/log?${query.toString()}`
			)
		)
	}
}
